import { IHashGenerationParams } from "./paymentModels";

export type ISecurityKeyGenerationParams = {
    UserIdentity: string
};

export type IDmsRequestParams = {
    RetailerCode: string,
    DistributorCode: string
}

export type IDmsHashGenerationRequest = {
    RetailerCode: string,
    DistributorCode: string,
    InvoiceList: IHashGenerationParams,
    ReferenceNo: string,
    TotalAmount: number
}